import React, { FC, useEffect } from 'react';
import styled from 'styled-components';

interface NgErrorMessageProps {
  message?: string | null;
  logError?: boolean;
}

const StyledMessage = styled.p`
  color: ${({ theme }) => theme.palette.error};
`;

export const NgErrorMessage: FC<NgErrorMessageProps> = ({ message, logError = false }) => {

  // log message for sentry
  useEffect(() => {
    if (logError && message) {
      console.error(message)
    }
  }, [logError]);

  if (!message) {
    return null;
  }

  return <StyledMessage className="error error-message">{message}</StyledMessage>;
};
